const dateFormats = {
  year: [{
    label: '2020',
    value: 'YYYY',
  }, {
    label: '\'20',
    value: '\'YY',
  }],
  month: [{
    label: 'Jan 2020',
    value: 'MMM YYYY',
  }, {
    label: 'January 2020',
    value: 'MMMM YYYY',
  }, {
    label: 'Jan \'20',
    value: 'MMM \'YY',
  }, {
    label: 'January \'20',
    value: 'MMMM \'YY',
  }, {
    label: '1/2020',
    value: 'M/YYYY',
  }, {
    label: '01/2020',
    value: 'MM/YYYY',
  }, {
    label: '1/20',
    value: 'M/YY',
  }, {
    label: '01/20',
    value: 'MM/YY',
  }],
  week: [{
    label: 'Week of 01/01/2020',
    value: '[Week of] MM/DD/YYYY',
  }, {
    label: 'Week of 1/1/20',
    value: '[Week of] M/D/YY',
  }, {
    label: 'Week of Jan 1',
    value: '[Week of] MMM D',
  }, {
    label: 'Week of January 1st',
    value: '[Week of] MMMM Do',
  }],
  day: [{
    label: '1/1/20',
    value: 'M/D/YY',
  }, {
    label: '01/01/20',
    value: 'MM/DD/YY',
  }, {
    label: '1/1/2020',
    value: 'M/D/YYYY',
  }, {
    label: '01/01/2020',
    value: 'MM/DD/YYYY',
  }],
};

export default dateFormats;
